import { ipsos, supuesto } from ".";

// Lámina 106, base 400.
const P_MEDIO = "¿Qué medio utiliza para llegar al trabajo?";
const P_VALORACION = "¿Qué valora más en un medio de transporte?";
const P_USA_APPS = "¿Ha usado aplicaciones de transporte?";
const P_INSTALADAS = "¿Qué apps de transporte tiene instaladas?";
const P_PREFERIDA = "¿Cuál es su app de transporte preferida o más usada?";

export const IPSOS_TRANSPORTE = {
  // No se muestra ni se usa en ningún cálculo hoy (dato Ipsos muerto, se preserva igual que en el código actual)
  medioTransporte: {
    "Locomoción colectiva": ipsos(0.519, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    "Vehículo particular": ipsos(0.211, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    Metro: ipsos(0.164, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    Caminando: ipsos(0.042, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    "Taxi / Aplicaciones": ipsos(0.027, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    Scooter: ipsos(0.02, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    Micro: ipsos(0.009, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    Bicicleta: ipsos(0.005, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
    "Vehículo empresa": ipsos(0.003, { lamina: 106, pregunta: P_MEDIO, base: 400 }),
  },

  valoracion: {
    Rapidez: ipsos(0.724, { lamina: 106, pregunta: P_VALORACION, base: 400 }),
    Comodidad: ipsos(0.219, { lamina: 106, pregunta: P_VALORACION, base: 400 }),
    Costo: ipsos(0.05, { lamina: 106, pregunta: P_VALORACION, base: 400 }),
    Seguridad: ipsos(0.007, { lamina: 106, pregunta: P_VALORACION, base: 400 }),
  },

  usaApps: ipsos(0.891, { lamina: 106, pregunta: P_USA_APPS, base: 400 }),
  noUsaApps: ipsos(0.109, { lamina: 106, pregunta: P_USA_APPS, base: 400 }),

  appsInstaladas: {
    Uber: ipsos(0.835, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
    Cabify: ipsos(0.251, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
    Didi: ipsos(0.168, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
    Ninguna: ipsos(0.094, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
    Otra: ipsos(0.017, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
    Tranvip: ipsos(0.017, { lamina: 106, pregunta: P_INSTALADAS, base: 400, nota: "multirespuesta" }),
  },

  appPreferida: {
    Uber: ipsos(0.798, { lamina: 106, pregunta: P_PREFERIDA, base: 400 }),
    Cabify: ipsos(0.069, { lamina: 106, pregunta: P_PREFERIDA, base: 400 }),
    Didi: ipsos(0.051, { lamina: 106, pregunta: P_PREFERIDA, base: 400 }),
    Ninguna: ipsos(0.083, { lamina: 106, pregunta: P_PREFERIDA, base: 400 }),
  },
};

// Supuestos comerciales (CLP) — precio por viaje, corto/medio/largo, sin fuente Ipsos
export const PRECIOS_VIAJE = {
  Uber: {
    corto: supuesto(3500, { nota: "precio viaje corto" }),
    medio: supuesto(6500, { nota: "precio viaje medio" }),
    largo: supuesto(12000, { nota: "precio viaje largo" }),
  },
  Cabify: {
    corto: supuesto(3800, { nota: "precio viaje corto" }),
    medio: supuesto(7000, { nota: "precio viaje medio" }),
    largo: supuesto(13000, { nota: "precio viaje largo" }),
  },
  Didi: {
    corto: supuesto(3200, { nota: "precio viaje corto" }),
    medio: supuesto(6000, { nota: "precio viaje medio" }),
    largo: supuesto(11000, { nota: "precio viaje largo" }),
  },
};

// Frecuencia de uso estimada (viajes por mes) — supuesto comercial, no Ipsos
export const FRECUENCIA_USO = {
  intensivo: {
    label: "Intensivo (diario)",
    viajesMes: supuesto(40, { nota: "viajes/mes" }),
    pct: supuesto(0.15, { nota: "% de usuarios" }),
  },
  frecuente: {
    label: "Frecuente (3-4x semana)",
    viajesMes: supuesto(14, { nota: "viajes/mes" }),
    pct: supuesto(0.25, { nota: "% de usuarios" }),
  },
  moderado: {
    label: "Moderado (1-2x semana)",
    viajesMes: supuesto(6, { nota: "viajes/mes" }),
    pct: supuesto(0.35, { nota: "% de usuarios" }),
  },
  ocasional: {
    label: "Ocasional (1-2x mes)",
    viajesMes: supuesto(1.5, { nota: "viajes/mes" }),
    pct: supuesto(0.25, { nota: "% de usuarios" }),
  },
};

export const ESCENARIOS_CAPTACION_TRANSPORTE = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];
